import { Dispatch, SetStateAction, useState } from 'react'
import TextField from '@mui/material/TextField';
import { inputProps } from '../../muiStyles/muiInput';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal';
import SearchIcon from '@mui/icons-material/Search';
import { centerClient } from '../../../shared/clients';
import context from '../context/shared';
import { observer } from 'mobx-react-lite';
import { ClientsTreeSearchResult } from '../../../shared/generated';
import { useBackButton } from '../../../utils/backButton';

export const FindDeviceInput = observer(() => {
    const { findDeviceId, setFindDeviceId } = context;
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            FindDevice(findDeviceId)
        }
    }
    return (
        <TextField placeholder="0000000"
            type="number"
            autoComplete="off"
            sx={inputProps}
            value={findDeviceId}
            onKeyDown={handleKeyDown} 
            onChange={(e) => {
                e.target.value = e.target.value.toString().slice(0, 7);
                setFindDeviceId(e.target.value);
            }}
            label="Найти устройство..." />
    );
})

export const FindDevice = (findDeviceId, setShow?) => {
    const { setFindDeviceId, setCurrentNode, setFoundDeviceToShow, setFoundDevices,
        setShowMultipleDevicesFound, setTabIndex } = context;

    const successFind = (res: ClientsTreeSearchResult[]) => {
        setTimeout(() => {
            if (res.length > 1) {
                setShowMultipleDevicesFound(true);
                setFoundDevices(res);
                setFindDeviceId("")
            }
            else if (res.length == 1) {
                if (setShow)
                    setShow(false);
                const searchResult = res[0];
                setCurrentNode(searchResult.node);
                const selectedNodeKey = searchResult.node.key;
                const foundDeviceToShow = {
                    nodeKey: selectedNodeKey,
                    deviceSerial: res[0].serial,
                    deviceModel: res[0].model
                };
                setFoundDeviceToShow(foundDeviceToShow);
                setFindDeviceId("");
                setTabIndex(0);
            }
            else {
                toast.error("Не удалось найти устройство", { autoClose: 2000 });
            }
        },0)

        //console.log(res);
    }
    const deviceId = findDeviceId;
    if (deviceId.length < 5) {
        toast.error("Введите хотя бы 5 символов");
        return;
    }
    centerClient.findDevice(deviceId)
            .then((res) => {
                const data = res.data;
                if (data)
                    successFind(data);
            })
            .catch(() => void 0);
}
interface IFindDeviceButtonsProps {
    setShow?: Dispatch<SetStateAction<boolean>>;
}
export const FindDeviceButton = observer((props: IFindDeviceButtonsProps) => {
    const { setShow } = props;
    const { findDeviceId } = context;
    return (
        <Button variant="custom" onClick={() => FindDevice(findDeviceId, setShow)}>Найти</Button>
    )
})
interface IFindDeviceModalProps {
    showButtonText?: boolean;
}
export const FindDeviceModal = observer((props: IFindDeviceModalProps) => {
    const [show, setShow] = useState(false);
    const { foundDevices, setCurrentNode, showMultipleDevicesFound, setShowMultipleDevicesFound,
        setFoundDeviceToShow, setShowRightClickPopup } = context;
    const { showButtonText } = props;
    const handleShow = () => {
        setShowRightClickPopup(false);
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    }
    const handleCloseMultipleDevicesFound = () => {
        setShowMultipleDevicesFound(false);
    }
    useBackButton(handleCloseMultipleDevicesFound, showMultipleDevicesFound);
    useBackButton(handleClose, show && !showMultipleDevicesFound);
    const handleChooseFoundDevice = (selectedDeviceModel, selectedDeviceSerial, selectedNode) => {
        const { setTabIndex } = context;
        setTabIndex(0);
        setTimeout(() => {
            setShowMultipleDevicesFound(false);
            setShow(false);
            const foundDeviceToShow = {
                nodeKey: selectedNode.key,
                deviceSerial: selectedDeviceSerial,
                deviceModel: selectedDeviceModel
            };
            setFoundDeviceToShow(foundDeviceToShow);
            setCurrentNode(selectedNode);
        }, 0);

    }
    return (
        <>
            <Button title="Поиск устройства" onClick={handleShow} variant="transparent" className="centerButton"><SearchIcon />{showButtonText && "Поиск устройства"}</Button>
            <Modal id="addDeviceContainer" show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Поиск устройства</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FindDeviceInput />
                </Modal.Body>
                <Modal.Footer>
                    <FindDeviceButton setShow={setShow} />
                    <Button variant="custom" onClick={handleClose}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
            <Modal id="foundDevicesContainer" show={showMultipleDevicesFound} onHide={handleCloseMultipleDevicesFound}>
                <Modal.Header>
                    <Modal.Title>Найденные устройства</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {foundDevices.map((foundDevice) => {
                        return (
                            <Button
                                style={{marginBottom:'.5rem'}}
                                variant="custom"
                                key={foundDevice.node.key + foundDevice.model + foundDevice.serial}
                                onClick={() => handleChooseFoundDevice(foundDevice.model, foundDevice.serial, foundDevice.node)}>
                                {
                                    foundDevice.client + " -> " + foundDevice.login + ": " +
                                    foundDevice.modelName + " " + foundDevice.serial
                                }
                            </Button>
                        )
                    })}            
                </Modal.Body>
            </Modal>
        </>        
    )
})